import { useSyncExternalStore } from 'react';
function noop() {
  // No-op
}
function subscribe() {
  return noop;
}
export function useIsHydrated() {
  return useSyncExternalStore(subscribe, _temp, _temp2);
}
function _temp2() {
  return false;
}
function _temp() {
  return true;
}